import { Typography } from '@mui/material';
import CardsApprovalOdds from './CardsApprovalOdds';
import { getCardsApprovalOddsValues } from './utils';

export const getCardsApprovalOddsDriver = (
  approvalOdds: string,
  isLoading: boolean,
  desktopStyle?: boolean,
) => {
  const approvalLikelihood = getCardsApprovalOddsValues(approvalOdds);
  return {
    label: 'Your approval odds',
    value: (
      <CardsApprovalOdds
        approvalLikelihood={approvalLikelihood}
        isLoading={isLoading}
        desktopStyle={desktopStyle}
      />
    ),
    labelTooltip: (
      <Typography variant="textSmall">
        We think your odds of getting approved for this card are{' '}
        <Typography variant="textSmallBold">{approvalLikelihood?.label ?? ''} </Typography>
        based on your credit score and other factors from your TransUnion credit report. That said,
        these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers
        use different criteria than we do.
      </Typography>
    ),
    valueTooltipHasHtml: true,
  };
};
